export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A time string with format HH:mm:ss.SSS */
  Time: any;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  platform: Enum_Appversion_Platform;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updateUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version: Scalars['String'];
};

export type AppVersionEntityResponseCollection = {
  __typename?: 'AppVersionEntityResponseCollection';
  nodes: Array<AppVersion>;
  pageInfo: Pagination;
};

export type AppVersionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AppVersionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AppVersionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AppVersionFiltersInput>>>;
  platform?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updateUrl?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<StringFilterInput>;
};

export type AppVersionInput = {
  locale?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Enum_Appversion_Platform>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  updateUrl?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nei?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentNotificationsNotificationTime = {
  __typename?: 'ComponentNotificationsNotificationTime';
  id: Scalars['ID'];
  time?: Maybe<Scalars['Time']>;
};

export type ComponentNotificationsNotificationTimeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNotificationsNotificationTimeFiltersInput>>>;
  not?: InputMaybe<ComponentNotificationsNotificationTimeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNotificationsNotificationTimeFiltersInput>>>;
  time?: InputMaybe<TimeFilterInput>;
};

export type ComponentNotificationsNotificationTimeInput = {
  id?: InputMaybe<Scalars['ID']>;
  time?: InputMaybe<Scalars['Time']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  contains?: InputMaybe<Scalars['Date']>;
  containsi?: InputMaybe<Scalars['Date']>;
  endsWith?: InputMaybe<Scalars['Date']>;
  eq?: InputMaybe<Scalars['Date']>;
  eqi?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nei?: InputMaybe<Scalars['Date']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']>;
  notContainsi?: InputMaybe<Scalars['Date']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  startsWith?: InputMaybe<Scalars['Date']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  nei?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export type Day = {
  __typename?: 'Day';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['Date']>;
  documentId: Scalars['ID'];
  hoursOff: Array<Maybe<HoursOff>>;
  hoursOff_connection?: Maybe<HoursOffRelationResponseCollection>;
  isSick?: Maybe<Scalars['Boolean']>;
  pendings: Array<Maybe<PendingPunch>>;
  pendings_connection?: Maybe<PendingPunchRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  punches: Array<Maybe<Punch>>;
  punches_connection?: Maybe<PunchRelationResponseCollection>;
  totalHoursOff?: Maybe<Scalars['Float']>;
  uid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUser>;
  vacation?: Maybe<Scalars['Boolean']>;
};


export type DayHoursOffArgs = {
  filters?: InputMaybe<HoursOffFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DayHoursOff_ConnectionArgs = {
  filters?: InputMaybe<HoursOffFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DayPendingsArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DayPendings_ConnectionArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DayPunchesArgs = {
  filters?: InputMaybe<PunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DayPunches_ConnectionArgs = {
  filters?: InputMaybe<PunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DayEntityResponse = {
  __typename?: 'DayEntityResponse';
  data?: Maybe<Day>;
};

export type DayEntityResponseCollection = {
  __typename?: 'DayEntityResponseCollection';
  nodes: Array<Day>;
  pageInfo: Pagination;
};

export type DayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DayFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  hoursOff?: InputMaybe<HoursOffFiltersInput>;
  isSick?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<DayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DayFiltersInput>>>;
  pendings?: InputMaybe<PendingPunchFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  punches?: InputMaybe<PunchFiltersInput>;
  totalHoursOff?: InputMaybe<FloatFilterInput>;
  uid?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  vacation?: InputMaybe<BooleanFilterInput>;
};

export type DayInput = {
  date?: InputMaybe<Scalars['Date']>;
  hoursOff?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isSick?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  pendings?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  punches?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  totalHoursOff?: InputMaybe<Scalars['Float']>;
  uid?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
  vacation?: InputMaybe<Scalars['Boolean']>;
};

export type DayRelationResponseCollection = {
  __typename?: 'DayRelationResponseCollection';
  nodes: Array<Day>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID'];
};

export enum Enum_Appversion_Platform {
  Android = 'android',
  Ios = 'ios'
}

export enum Enum_Userspermissionsuser_Company {
  Immerxive = 'Immerxive',
  Mediacross = 'Mediacross'
}

export enum Enum_Userspermissionsuser_Department {
  Account = 'account',
  Amministrazione = 'amministrazione',
  Creativo = 'creativo',
  Immerxive = 'immerxive',
  It = 'it',
  Video = 'video'
}

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nei?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = AppVersion | ComponentNotificationsNotificationTime | Day | HoursOff | I18NLocale | Notification | NotificationToken | PendingPunch | Punch | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | WorkingDay | WorkingWeek;

export type HoursOff = {
  __typename?: 'HoursOff';
  createdAt?: Maybe<Scalars['DateTime']>;
  day?: Maybe<Day>;
  documentId: Scalars['ID'];
  from?: Maybe<Scalars['Time']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['Time']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HoursOffEntityResponseCollection = {
  __typename?: 'HoursOffEntityResponseCollection';
  nodes: Array<HoursOff>;
  pageInfo: Pagination;
};

export type HoursOffFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<HoursOffFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DayFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  from?: InputMaybe<TimeFilterInput>;
  not?: InputMaybe<HoursOffFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HoursOffFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  to?: InputMaybe<TimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type HoursOffInput = {
  day?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['Time']>;
  locale?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['Time']>;
};

export type HoursOffRelationResponseCollection = {
  __typename?: 'HoursOffRelationResponseCollection';
  nodes: Array<HoursOff>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  nei?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nei?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nei?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAppVersion?: Maybe<AppVersion>;
  createDay?: Maybe<Day>;
  createHoursOff?: Maybe<HoursOff>;
  createNotification?: Maybe<Notification>;
  createNotificationToken?: Maybe<NotificationToken>;
  createPendingPunch?: Maybe<PendingPunch>;
  createPunch?: Maybe<Punch>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWorkingDay?: Maybe<WorkingDay>;
  createWorkingWeek?: Maybe<WorkingWeek>;
  deleteAppVersion?: Maybe<DeleteMutationResponse>;
  deleteDay?: Maybe<DeleteMutationResponse>;
  deleteHoursOff?: Maybe<DeleteMutationResponse>;
  deleteNotification?: Maybe<DeleteMutationResponse>;
  deleteNotificationToken?: Maybe<DeleteMutationResponse>;
  deletePendingPunch?: Maybe<DeleteMutationResponse>;
  deletePunch?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWorkingDay?: Maybe<DeleteMutationResponse>;
  deleteWorkingWeek?: Maybe<DeleteMutationResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  setIsSick?: Maybe<DayEntityResponse>;
  setVacations?: Maybe<DayEntityResponseCollection>;
  updateAppVersion?: Maybe<AppVersion>;
  updateDay?: Maybe<Day>;
  updateHoursOff?: Maybe<HoursOff>;
  updateNotification?: Maybe<Notification>;
  updateNotificationToken?: Maybe<NotificationToken>;
  updatePendingPunch?: Maybe<PendingPunch>;
  updatePunch?: Maybe<Punch>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWorkingDay?: Maybe<WorkingDay>;
  updateWorkingWeek?: Maybe<WorkingWeek>;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateAppVersionArgs = {
  data: AppVersionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDayArgs = {
  data: DayInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateHoursOffArgs = {
  data: HoursOffInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateNotificationArgs = {
  data: NotificationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateNotificationTokenArgs = {
  data: NotificationTokenInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePendingPunchArgs = {
  data: PendingPunchInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePunchArgs = {
  data: PunchInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateWorkingDayArgs = {
  data: WorkingDayInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateWorkingWeekArgs = {
  data: WorkingWeekInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationDeleteAppVersionArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteDayArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteHoursOffArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteNotificationArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteNotificationTokenArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeletePendingPunchArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeletePunchArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWorkingDayArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteWorkingWeekArgs = {
  documentId: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationSetIsSickArgs = {
  date: Scalars['Date'];
  isSick: Scalars['Boolean'];
  user: Scalars['ID'];
};


export type MutationSetVacationsArgs = {
  dates: Array<InputMaybe<Scalars['Date']>>;
  user: Scalars['ID'];
};


export type MutationUpdateAppVersionArgs = {
  data: AppVersionInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDayArgs = {
  data: DayInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateHoursOffArgs = {
  data: HoursOffInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateNotificationArgs = {
  data: NotificationInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateNotificationTokenArgs = {
  data: NotificationTokenInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePendingPunchArgs = {
  data: PendingPunchInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePunchArgs = {
  data: PunchInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUpdateWorkingDayArgs = {
  data: WorkingDayInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateWorkingWeekArgs = {
  data: WorkingWeekInput;
  documentId: Scalars['ID'];
  status?: InputMaybe<PublicationStatus>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  times?: Maybe<Array<Maybe<ComponentNotificationsNotificationTime>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type NotificationTimesArgs = {
  filters?: InputMaybe<ComponentNotificationsNotificationTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  nodes: Array<Notification>;
  pageInfo: Pagination;
};

export type NotificationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  times?: InputMaybe<ComponentNotificationsNotificationTimeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NotificationInput = {
  locale?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  times?: InputMaybe<Array<InputMaybe<ComponentNotificationsNotificationTimeInput>>>;
  user?: InputMaybe<Scalars['ID']>;
};

export type NotificationToken = {
  __typename?: 'NotificationToken';
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type NotificationTokenEntityResponseCollection = {
  __typename?: 'NotificationTokenEntityResponseCollection';
  nodes: Array<NotificationToken>;
  pageInfo: Pagination;
};

export type NotificationTokenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationTokenFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationTokenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationTokenFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  token?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NotificationTokenInput = {
  locale?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type NotificationTokenRelationResponseCollection = {
  __typename?: 'NotificationTokenRelationResponseCollection';
  nodes: Array<NotificationToken>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type PendingPunch = {
  __typename?: 'PendingPunch';
  approved?: Maybe<Scalars['Boolean']>;
  approvedBy?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  day?: Maybe<Day>;
  documentId: Scalars['ID'];
  in?: Maybe<Scalars['Time']>;
  note?: Maybe<Scalars['String']>;
  oldIn?: Maybe<Scalars['Time']>;
  oldOut?: Maybe<Scalars['Time']>;
  out?: Maybe<Scalars['Time']>;
  penalty?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  punch?: Maybe<Punch>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PendingPunchEntityResponseCollection = {
  __typename?: 'PendingPunchEntityResponseCollection';
  nodes: Array<PendingPunch>;
  pageInfo: Pagination;
};

export type PendingPunchFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PendingPunchFiltersInput>>>;
  approved?: InputMaybe<BooleanFilterInput>;
  approvedBy?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DayFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  in?: InputMaybe<TimeFilterInput>;
  not?: InputMaybe<PendingPunchFiltersInput>;
  note?: InputMaybe<StringFilterInput>;
  oldIn?: InputMaybe<TimeFilterInput>;
  oldOut?: InputMaybe<TimeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<PendingPunchFiltersInput>>>;
  out?: InputMaybe<TimeFilterInput>;
  penalty?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  punch?: InputMaybe<PunchFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PendingPunchInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  approvedBy?: InputMaybe<Scalars['ID']>;
  day?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Scalars['Time']>;
  locale?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  oldIn?: InputMaybe<Scalars['Time']>;
  oldOut?: InputMaybe<Scalars['Time']>;
  out?: InputMaybe<Scalars['Time']>;
  penalty?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  punch?: InputMaybe<Scalars['ID']>;
};

export type PendingPunchRelationResponseCollection = {
  __typename?: 'PendingPunchRelationResponseCollection';
  nodes: Array<PendingPunch>;
};

export enum PublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED'
}

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Punch = {
  __typename?: 'Punch';
  createdAt?: Maybe<Scalars['DateTime']>;
  day?: Maybe<Day>;
  documentId: Scalars['ID'];
  in?: Maybe<Scalars['Time']>;
  location: Scalars['String'];
  out?: Maybe<Scalars['Time']>;
  pendingPunches: Array<Maybe<PendingPunch>>;
  pendingPunches_connection?: Maybe<PendingPunchRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PunchPendingPunchesArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PunchPendingPunches_ConnectionArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PunchEntityResponseCollection = {
  __typename?: 'PunchEntityResponseCollection';
  nodes: Array<Punch>;
  pageInfo: Pagination;
};

export type PunchFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PunchFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DayFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  in?: InputMaybe<TimeFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PunchFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PunchFiltersInput>>>;
  out?: InputMaybe<TimeFilterInput>;
  pendingPunches?: InputMaybe<PendingPunchFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PunchInput = {
  day?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Scalars['Time']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  out?: InputMaybe<Scalars['Time']>;
  pendingPunches?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PunchRelationResponseCollection = {
  __typename?: 'PunchRelationResponseCollection';
  nodes: Array<Punch>;
};

export type Query = {
  __typename?: 'Query';
  appVersion?: Maybe<AppVersion>;
  appVersions: Array<Maybe<AppVersion>>;
  appVersions_connection?: Maybe<AppVersionEntityResponseCollection>;
  createOrGet?: Maybe<DayEntityResponse>;
  day?: Maybe<Day>;
  days: Array<Maybe<Day>>;
  days_connection?: Maybe<DayEntityResponseCollection>;
  hoursOff?: Maybe<HoursOff>;
  hoursOffs: Array<Maybe<HoursOff>>;
  hoursOffs_connection?: Maybe<HoursOffEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  notification?: Maybe<Notification>;
  notificationToken?: Maybe<NotificationToken>;
  notificationTokens: Array<Maybe<NotificationToken>>;
  notificationTokens_connection?: Maybe<NotificationTokenEntityResponseCollection>;
  notifications: Array<Maybe<Notification>>;
  notifications_connection?: Maybe<NotificationEntityResponseCollection>;
  pendingPunch?: Maybe<PendingPunch>;
  pendingPunches: Array<Maybe<PendingPunch>>;
  pendingPunches_connection?: Maybe<PendingPunchEntityResponseCollection>;
  punch?: Maybe<Punch>;
  punches: Array<Maybe<Punch>>;
  punches_connection?: Maybe<PunchEntityResponseCollection>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  workingDay?: Maybe<WorkingDay>;
  workingDays: Array<Maybe<WorkingDay>>;
  workingDays_connection?: Maybe<WorkingDayEntityResponseCollection>;
  workingWeek?: Maybe<WorkingWeek>;
  workingWeeks: Array<Maybe<WorkingWeek>>;
  workingWeeks_connection?: Maybe<WorkingWeekEntityResponseCollection>;
};


export type QueryAppVersionArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAppVersionsArgs = {
  filters?: InputMaybe<AppVersionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAppVersions_ConnectionArgs = {
  filters?: InputMaybe<AppVersionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCreateOrGetArgs = {
  date: Scalars['Date'];
  user: Scalars['ID'];
};


export type QueryDayArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDaysArgs = {
  filters?: InputMaybe<DayFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDays_ConnectionArgs = {
  filters?: InputMaybe<DayFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHoursOffArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHoursOffsArgs = {
  filters?: InputMaybe<HoursOffFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHoursOffs_ConnectionArgs = {
  filters?: InputMaybe<HoursOffFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationTokenArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationTokensArgs = {
  filters?: InputMaybe<NotificationTokenFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationTokens_ConnectionArgs = {
  filters?: InputMaybe<NotificationTokenFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotifications_ConnectionArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPendingPunchArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPendingPunchesArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPendingPunches_ConnectionArgs = {
  filters?: InputMaybe<PendingPunchFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPunchArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPunchesArgs = {
  filters?: InputMaybe<PunchFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPunches_ConnectionArgs = {
  filters?: InputMaybe<PunchFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingDayArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingDaysArgs = {
  filters?: InputMaybe<WorkingDayFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingDays_ConnectionArgs = {
  filters?: InputMaybe<WorkingDayFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingWeekArgs = {
  documentId: Scalars['ID'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingWeeksArgs = {
  filters?: InputMaybe<WorkingWeekFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryWorkingWeeks_ConnectionArgs = {
  filters?: InputMaybe<WorkingWeekFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  workflow?: InputMaybe<Scalars['ID']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nei?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type TimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  contains?: InputMaybe<Scalars['Time']>;
  containsi?: InputMaybe<Scalars['Time']>;
  endsWith?: InputMaybe<Scalars['Time']>;
  eq?: InputMaybe<Scalars['Time']>;
  eqi?: InputMaybe<Scalars['Time']>;
  gt?: InputMaybe<Scalars['Time']>;
  gte?: InputMaybe<Scalars['Time']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  lt?: InputMaybe<Scalars['Time']>;
  lte?: InputMaybe<Scalars['Time']>;
  ne?: InputMaybe<Scalars['Time']>;
  nei?: InputMaybe<Scalars['Time']>;
  not?: InputMaybe<TimeFilterInput>;
  notContains?: InputMaybe<Scalars['Time']>;
  notContainsi?: InputMaybe<Scalars['Time']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  startsWith?: InputMaybe<Scalars['Time']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  ext?: Maybe<Scalars['String']>;
  focalPoint?: Maybe<Scalars['JSON']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  documentId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  company?: Maybe<Enum_Userspermissionsuser_Company>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  days: Array<Maybe<Day>>;
  days_connection?: Maybe<DayRelationResponseCollection>;
  department?: Maybe<Enum_Userspermissionsuser_Department>;
  documentId: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  followedBy: Array<Maybe<UsersPermissionsUser>>;
  followedBy_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  followedUsers: Array<Maybe<UsersPermissionsUser>>;
  followedUsers_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  isPartTime?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  managers: Array<Maybe<UsersPermissionsUser>>;
  managers_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  mustPunch?: Maybe<Scalars['Boolean']>;
  notification?: Maybe<Notification>;
  notificationEnabled?: Maybe<Scalars['Boolean']>;
  notificationTokens: Array<Maybe<NotificationToken>>;
  notificationTokens_connection?: Maybe<NotificationTokenRelationResponseCollection>;
  provider?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  punchShiftLimitMinutes?: Maybe<Scalars['Int']>;
  redmineUserId?: Maybe<Scalars['Int']>;
  rewardCoins?: Maybe<Scalars['Int']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  workingWeek?: Maybe<WorkingWeek>;
};


export type UsersPermissionsUserDaysArgs = {
  filters?: InputMaybe<DayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserDays_ConnectionArgs = {
  filters?: InputMaybe<DayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserFollowedByArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserFollowedBy_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserFollowedUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserFollowedUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserManagersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserManagers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotificationTokensArgs = {
  filters?: InputMaybe<NotificationTokenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotificationTokens_ConnectionArgs = {
  filters?: InputMaybe<NotificationTokenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  company?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  days?: InputMaybe<DayFiltersInput>;
  department?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  followedBy?: InputMaybe<UsersPermissionsUserFiltersInput>;
  followedUsers?: InputMaybe<UsersPermissionsUserFiltersInput>;
  isPartTime?: InputMaybe<BooleanFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  managers?: InputMaybe<UsersPermissionsUserFiltersInput>;
  mustPunch?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  notificationEnabled?: InputMaybe<BooleanFilterInput>;
  notificationTokens?: InputMaybe<NotificationTokenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  punchShiftLimitMinutes?: InputMaybe<IntFilterInput>;
  redmineUserId?: InputMaybe<IntFilterInput>;
  rewardCoins?: InputMaybe<IntFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
  workingWeek?: InputMaybe<WorkingWeekFiltersInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Enum_Userspermissionsuser_Company>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  days?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  department?: InputMaybe<Enum_Userspermissionsuser_Department>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  followedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  followedUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isPartTime?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  managers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  mustPunch?: InputMaybe<Scalars['Boolean']>;
  notification?: InputMaybe<Scalars['ID']>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationTokens?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  punchShiftLimitMinutes?: InputMaybe<Scalars['Int']>;
  redmineUserId?: InputMaybe<Scalars['Int']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  rewardCoins?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  workingWeek?: InputMaybe<Scalars['ID']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type WorkingDay = {
  __typename?: 'WorkingDay';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfTheWeek: Scalars['Int'];
  documentId: Scalars['ID'];
  end: Scalars['Time'];
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  start: Scalars['Time'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkingDayEntityResponseCollection = {
  __typename?: 'WorkingDayEntityResponseCollection';
  nodes: Array<WorkingDay>;
  pageInfo: Pagination;
};

export type WorkingDayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WorkingDayFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dayOfTheWeek?: InputMaybe<IntFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  end?: InputMaybe<TimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkingDayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WorkingDayFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  start?: InputMaybe<TimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type WorkingDayInput = {
  dayOfTheWeek?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Time']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['Time']>;
};

export type WorkingDayRelationResponseCollection = {
  __typename?: 'WorkingDayRelationResponseCollection';
  nodes: Array<WorkingDay>;
};

export type WorkingWeek = {
  __typename?: 'WorkingWeek';
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId: Scalars['ID'];
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workingDays: Array<Maybe<WorkingDay>>;
  workingDays_connection?: Maybe<WorkingDayRelationResponseCollection>;
};


export type WorkingWeekWorkingDaysArgs = {
  filters?: InputMaybe<WorkingDayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type WorkingWeekWorkingDays_ConnectionArgs = {
  filters?: InputMaybe<WorkingDayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WorkingWeekEntityResponseCollection = {
  __typename?: 'WorkingWeekEntityResponseCollection';
  nodes: Array<WorkingWeek>;
  pageInfo: Pagination;
};

export type WorkingWeekFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WorkingWeekFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkingWeekFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WorkingWeekFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workingDays?: InputMaybe<WorkingDayFiltersInput>;
};

export type WorkingWeekInput = {
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  workingDays?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};
